import detectMobileDevice from 'is-mobile';

export default function getFontSize(messageConfig) {
  const isMobile = detectMobileDevice();

  const mobileFontSize =
    messageConfig.fontSize && messageConfig.fontSize.mobile ? messageConfig.fontSize.mobile : 14;
  const desktopFontSize =
    messageConfig.fontSize && messageConfig.fontSize.desktop ? messageConfig.fontSize.desktop : 14;

  const currentFontSize = isMobile ? mobileFontSize : desktopFontSize;
  return currentFontSize;
}
